import { render, staticRenderFns } from "./events-widget.vue?vue&type=template&id=77f6e65e"
import script from "./events-widget.vue?vue&type=script&lang=ts"
export * from "./events-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports